<!-- FOOTER -->
<section class="call-now-section">
  <div class="container">
    <div class="row">
      <div class="col-md-8">
        <p>Need Help Renting The Right Product</p>
      </div>
      <div class="col-md-4">
        <a href="tel:+917904998687" class="btn btn-call">Call Us</a>
      </div>
    </div>
  </div>
</section>

<div class="footer-wrap">
  <div class="container">
    <div class="row footer clearfix">
      <div class="col-md-4">
        <div class="widget">
          <div class="row">
            <div class="col-md-12">
              <h3>Get in Touch</h3>
            </div>
          </div>
          <ul>
            <li>
              <a href="mailto:crazyphotographystudio@gmail.com" class="lowercase">
                <i class="fa fa-envelope" aria-hidden="true"></i> crazyphotographystudio@gmail.com </a>
            </li>
            <li>
              <a href="tel:7904998687">
                <i class="fa fa-phone"></i> +91 7904998687 </a>
            </li>
            <li>
              <a
                href="https://wa.me/+917904998687?text=Hi, I need your help renting a product from https://crazy-photography-studio.web.app/ . Please provide your details - Equipment type, Start Date, End Date">
                <i class="fa fa-phone"></i> +91 7904998687
              </a>
            </li>
          </ul>
          <a href="https://wa.me/+917904998687?text=Hi, I need your help renting a product from https://crazy-photography-studio.web.app/ . Please provide your details - Equipment type, Start Date, End Date"
            class="phone-whatsapp"><i class="fa-brands fa-whatsapp"></i></a>
        </div>

        <div class="row">
          <div class="col-md-12">
            <h3>CONNECT SOCIAL</h3>
          </div>
        </div>

        <!-- ASDF -->
        <ul class="listar-socialicons">
          <li class="list-icon"><a><i class="ion ion-social-facebook"></i></a>
          </li>
          <li class="list-icon"><a href="#"><i class="ion ion-social-twitter"></i></a></li>
          <li class="list-icon"><a href="https://www.instagram.com/crazy_photography_studio/"><i
                class="ion ion-social-linkedin"></i></a></li>
          <li class="list-icon"><a href="https://goo.gl/maps/hNe7KVAtpZkAdjS4A"><i
                class="fa-solid fa-map-location-dot"></i></a></li>
        </ul>

        <!-- ASDF -->
        <!-- <div class="social-icon">

						<a class="twet" href="" title="Twitter" target="_blank"></a>
						<a class="fb" href="" title="Facebook" target="_blank"></a>
						<a class="google" href="" title="Google+" target="_blank"></a>
						<a class="pin" href="" title="Instagram" target="_blank"> </a>
					</div> -->

        <div class="clearfix"></div>
      </div>

      <div class="col-md-4">
        <div class="widget">
          <div class="row">
            <div class="col-md-12">
              <h3>Category</h3>
            </div>
          </div>
          <ul>
            <li><a>Camera</a></li>
            <li><a>Lens</a></li>
            <li><a>Videography
                Equipments</a></li>
            <li><a>Go Pro & Mount</a></li>
            <li><a>Wedding Kit</a></li>
            <li><a>Youtube & Vlogging
                Gears</a></li>
            <li><a>Travel Gears</a></li>
            <li><a>Film & Cinema
                Equipments</a></li>
            <li><a>Wildlife
                Photography DSLR & Lens on rent</a></li>

          </ul>

        </div>
      </div>
      <div class="col-md-4">
        <div class="widget">
          <div class="row">
            <div class="col-md-12">
              <h3>Customer Service</h3>
            </div>
          </div>

          <ul>

            <li><a>About Us</a></li>
            <li><a role="button" [routerLink]="['/pages/rental/privacy']" routerLinkActive="router-link-active" >Privacy Policy</a></li>
            <li><a>Terms & Condition</a></li>
            <li><a>Cancellation Policy</a></li>
            <li role="button" [routerLink]="['/pages/rental/kyc-terms']" routerLinkActive="router-link-active"><a>KYC Policy</a></li>
            <li><a>How It Works</a></li>

            <li><a target="_blank">Blogs</a></li>
          </ul>
          <img src="https://www.rentoclick.com/images/home/visa.png" class="visa">
        </div>

      </div>



    </div>
  </div>
</div>
<!-- FOOTER -->

<div class="container">
  <div class="row">
    <div class="col-md-12 text-center">
      <p class="m-0 pt-2 rights">© 2023 Crazy Photography Studio, All Rights Reserved
      </p>
    </div>
  </div>
</div>

<section id="ig_footer" class="inline-data justify-content-center align-self-center">
  <ul>
    <li>
      <a (click)="goHome()"><i class="fa fa-home"></i></a>
    </li>
    <li>
      <a (click)="goDslr()"><i class="fa-solid fa-camera"></i></a>
    </li>
    <li> <a href="tel:7904998687">
      <i class="fa-solid fa-square-phone"></i></a>
    </li>
    <li>
      <nb-actions size="small">
        <nb-action class="user-action" *nbIsGranted="['view', 'user']" >
          <nb-user [nbContextMenu]="userMenu"
                   [onlyPicture]="userPictureOnly"
                   [picture]="user?.imageUrl">
          </nb-user>
        </nb-action>
      </nb-actions>
      <!-- <a (click)="goHome()"><img src="/assets/images/crazylogo.png" alt=""></a> -->
    </li>
  </ul>
</section>

<!-- <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display': myorderPopup ? 'block' : 'none'}">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header head-color">
        <h4 class="modal-title un-colorc">My Orders</h4>
        <button type="button" class="close" aria-label="Close" (click)="myOrderClose()"><span
            aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body p-0">
        <ngx-my-orders></ngx-my-orders>
      </div>
      <div class="modal-footer head-color">
        <button type="button" class="btn btn-default" (click)="myOrderClose()">Close</button>
      </div>
    </div>
  </div>
</div> -->
